import { inject } from '@angular/core';
import type { Route } from '@angular/router';
import { PermissionService } from '../../../../../core/services/permission.service';
import { ClaimsUploadHandoff } from './shared/claims-upload-handoff';
import { CLAIMS_SEGMENT_LIST, claimsLandingUrl } from './shell/claims-segments';

/**
 * `/benefits/claims` (SP4c D1, ruling Q8): the Claims tab's own shell and segments. `BENEFITS_ROUTE` registers it and
 * adds `permissionGuard` to every page here (ruling Q9 — this file does not import benefits.routes.ts).
 */
export const CLAIMS_ROUTE: Route = {
  path: 'claims',
  // One hand-off per claims visit (ruling Q16).
  providers: [ClaimsUploadHandoff],
  loadComponent: () => import('./shell/claims-shell.component').then((m) => m.ClaimsShellComponent),
  children: [
    {
      // The first segment the caller may open, else /unauthorized.
      path: '',
      pathMatch: 'full',
      redirectTo: () => {
        const permissions = inject(PermissionService);
        return claimsLandingUrl((anyOf) => permissions.hasAny(anyOf), inject(CLAIMS_SEGMENT_LIST));
      },
    },
    {
      path: 'imports',
      loadComponent: () => import('./imports/claim-imports-page.component').then((m) => m.ClaimImportsPageComponent),
    },
    {
      // Before `imports/:batchId`: the literal `new` must win.
      path: 'imports/new',
      loadComponent: () => import('./imports/new/claim-import-wizard-page.component').then((m) => m.ClaimImportWizardPageComponent),
    },
    {
      path: 'imports/:batchId',
      loadComponent: () => import('./imports/review/claim-review-page.component').then((m) => m.ClaimReviewPageComponent),
    },
    {
      path: 'register',
      loadComponent: () => import('./register/claims-register-page.component').then((m) => m.ClaimsRegisterPageComponent),
    },
    {
      path: 'profiles',
      loadComponent: () => import('./profiles/claim-profiles-page.component').then((m) => m.ClaimProfilesPageComponent),
    },
  ],
};
